<template>
  <v-row>
    <v-col cols="12">
      <TablaCandidatosBolson
        titulo="Personas del bolsón"
        :paginacion="paginacionCandidatosCompleta"
        :listado="candidatosFiltradosPaginados"
        @cambio-pagina="setPaginacionCandidatos"
        @cambio-por-pagina="cambioPorPaginaCandidatos"
        @filtrar="filtrarCandidatos"
        @limpiar="limpiarCandidatos"
      >
        <template #btnOptions>
          <v-btn class="lowercase-text px-4" color="primary" style="text-transform: none !important" rounded @click="aplicarTodos">
            Aplicar todos
          </v-btn>
        </template>
        <template #btnAccionIcono="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="seleccionar(item)">
                <v-icon color="primary">mdi-account-check-outline</v-icon>
              </v-btn>
            </template>
            <span>Seleccionar</span>
          </v-tooltip>
        </template>
      </TablaCandidatosBolson>
    </v-col>
    <v-col cols="12">
      <TablaCandidatosBolson
        titulo="Personas seleccionadas"
        :paginacion="paginacionSeleccionadosCompleta"
        :listado="seleccionadosFiltradosPaginados"
        @cambio-pagina="setPaginacionSeleccionados"
        @cambio-por-pagina="cambioPorPaginaSeleccionados"
        @filtrar="filtrarSeleccionados"
        @limpiar="limpiarSeleccionados"
      >
        <template #btnOptions>
          <v-btn class="lowercase-text px-4" color="primary" style="text-transform: none !important" rounded @click="removerTodos">
            Remover todos
          </v-btn>
        </template>
        <template #btnAccionIcono="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="remover(item)">
                <v-icon color="primary">mdi-account-minus-outline</v-icon>
              </v-btn>
            </template>
            <span>Remover</span>
          </v-tooltip>
        </template>
      </TablaCandidatosBolson>
    </v-col>

    <!-- Modal Confirm -->
    <AppDialog :title="modalTitle"
        v-model="confirmModal" class="rounded-sm">
        <template #body>
            <v-row class="d-flex justify-center items-center mt-5 mb-2">
                <v-col cols="12" class="text-center text-body-1" style="color: #313945;">
                    Al confirmar la acción, {{ modalText }}
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" class="text-center">
                    <v-btn width="150px" height="40" color="primary" rounded outlined
                        class="text-none font-weight-black ma-1" @click="confirmModal = false">
                        Cancelar
                    </v-btn>
                    <v-btn width="150px" height="40" color="primary" rounded class="text-none font-weight-black ma-1"
                        @click="executeAction">
                        {{ ['descartar', 'removerTodos'].includes(actionType) ? 'Descartar' : 'Aplicar' }}
                    </v-btn>
                </v-col>
            </v-row>
        </template>
    </AppDialog>

  </v-row>
</template>

<script>
import TablaCandidatosBolson from "./TablaCandidatosBolson.vue"
import solicitudServices from "@/services/solicitud.services";

export default {
  name: "GestionCandidatosBolson",
  components: {
    TablaCandidatosBolson
  },
  data() {
    return {
      //Modal
      confirmModal: false,
      actionType: null,
      selectedItem: null,
      
      //Candidatos
      buscarCandidato: null, 
      paginacionCandidatos: {
        pagina: 1,
        por_pagina: 5,
        total_registro: 1
      },
      listadoCandidatos: [],
      //Seleccionados
      buscarSeleccionados: null, 
      paginacionSeleccionados: {
        pagina: 1,
        por_pagina: 5,
        total_registro: 0
      },
      listadoSeleccionados: [],
    }
  },
  computed: {
    candidatosFiltrados() {
      if (!this.buscarCandidato) return this.listadoCandidatos;
      const lowerSearch = this.buscarCandidato.toLowerCase();
      return this.listadoCandidatos.filter(c => 
        (c.numero_documento && c.numero_documento.toLowerCase().includes(lowerSearch)) ||
        (c.nombres && c.nombres.toLowerCase().includes(lowerSearch)) ||
        (c.apellidos && c.apellidos.toLowerCase().includes(lowerSearch)) ||
        (c.plaza_seleccionada && c.plaza_seleccionada.toLowerCase().includes(lowerSearch))
      );
    },
    candidatosFiltradosPaginados() {
      const inicio = (this.paginacionCandidatos.pagina - 1) * this.paginacionCandidatos.por_pagina;
      const fin = inicio + this.paginacionCandidatos.por_pagina;
      return this.candidatosFiltrados.slice(inicio, fin);
    },
    paginacionCandidatosCompleta() {
      return {
        ...this.paginacionCandidatos,
        total_registro: this.candidatosFiltrados.length
      }
    },
    seleccionadosFiltrados() {
      if (!this.buscarSeleccionados) return this.listadoSeleccionados;
      const lowerSearch = this.buscarSeleccionados.toLowerCase();
      return this.listadoSeleccionados.filter(c => 
        (c.numero_documento && c.numero_documento.toLowerCase().includes(lowerSearch)) ||
        (c.nombres && c.nombres.toLowerCase().includes(lowerSearch)) ||
        (c.apellidos && c.apellidos.toLowerCase().includes(lowerSearch)) ||
        (c.plaza_seleccionada && c.plaza_seleccionada.toLowerCase().includes(lowerSearch))
      );
    },
    seleccionadosFiltradosPaginados() {
      const inicio = (this.paginacionSeleccionados.pagina - 1) * this.paginacionSeleccionados.por_pagina;
      const fin = inicio + this.paginacionSeleccionados.por_pagina;
      return this.seleccionadosFiltrados.slice(inicio, fin);
    },
    paginacionSeleccionadosCompleta() {
      return {
        ...this.paginacionSeleccionados,
        total_registro: this.seleccionadosFiltrados.length
      }
    },
    modalTitle() {
      switch (this.actionType) {
        case 'aplicar': return 'Aplicar candidato';
        case 'aplicarTodos': return 'Aplicar candidatos';
        case 'descartar': return 'Descartar candidato';
        case 'removerTodos': return 'Descartar candidatos';
        default: return '';
      }
    },
    modalText() {
      switch (this.actionType) {
        case 'aplicar': return 'el candidato se aplicará';
        case 'aplicarTodos': return 'los candidatos se aplicarán';
        case 'descartar': return 'el candidato se removerá de la tabla de seleccionados';
        case 'removerTodos': return 'los candidatos se removerán de la tabla de seleccionados';
        default: return '';
      }
    }
  },
  watch: {
    listadoSeleccionados: {
      handler(newVal) {
        this.$store.dispatch('solicitud/setCandidatosBolsonSeleccionadosCount', newVal.length);
        this.$store.dispatch('solicitud/setCandidatosBolsonSeleccionados', newVal);
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.fetchCandidatos();
  },
  methods: {
    async fetchCandidatos() {
      try {
        const id_solicitud = this.$route.params.id;
        if (!id_solicitud) return;
        
        const response = await solicitudServices.getCandidatosBolson(id_solicitud);
        if (response.status === 200 || response.data) {
          const data = response.data || response;
          const mappedData = (Array.isArray(data) ? data : []).map(item => ({
            id: item.id_bolson,
            id_persona: item.id_persona,
            numero_documento: item.numero_documento,
            tipo_documento: item.tipo_documento,
            nombres: item.nombres,
            apellidos: item.apellidos,
            plaza_seleccionada: item.nombre_plaza,
            numero_telefono: item.telefono,
            promedio_evaluacion: item.promedio_evaluacion,
            evaluaciones: item.evaluaciones || [],
            seleccionado: item.seleccionado,
            direccion: item.direccion,
            departamento_residencia: item.departamento_residencia,
            distrito_residencia: item.distrito_residencia,
            pais_nacimiento: item.pais_nacimiento,
            fecha_nacimiento: item.fecha_nacimiento,
            email_personal: item.email_personal
          }));

          this.listadoCandidatos = mappedData.filter(c => !c.seleccionado);
          this.listadoSeleccionados = mappedData.filter(c => c.seleccionado);
        }
      } catch (error) {
      }
    },
    //Candidatos
    async setPaginacionCandidatos(page) {
      this.paginacionCandidatos.pagina = page
    },
    async cambioPorPaginaCandidatos(data) {
      this.paginacionCandidatos.por_pagina = data.por_pagina
      this.paginacionCandidatos.pagina = data.pagina
    },
    async filtrarCandidatos(data) {
      this.buscarCandidato = data.buscar;
      this.paginacionCandidatos.pagina = data.pagina;
    },
    async limpiarCandidatos(data) {
      this.buscarCandidato = data.buscar;
      this.paginacionCandidatos.pagina = data.pagina;
    },
    async seleccionar(item) {
      this.actionType = 'aplicar';
      this.selectedItem = item;
      this.confirmModal = true;
    },
    async aplicarTodos() {
      this.actionType = 'aplicarTodos';
      this.confirmModal = true;
    },
    //Seleccionados
    async setPaginacionSeleccionados(page) {
      this.paginacionSeleccionados.pagina = page
    },
    async cambioPorPaginaSeleccionados(data) {
      this.paginacionSeleccionados.por_pagina = data.por_pagina
      this.paginacionSeleccionados.pagina = data.pagina
    },
    async filtrarSeleccionados(data) {
      this.buscarSeleccionados = data.buscar;
      this.paginacionSeleccionados.pagina = data.pagina;
    },
    async limpiarSeleccionados(data) {
      this.buscarSeleccionados = data.buscar;
      this.paginacionSeleccionados.pagina = data.pagina;
    },
    async remover(item) {
      this.actionType = 'descartar';
      this.selectedItem = item;
      this.confirmModal = true;
    },
    async removerTodos() {
      this.actionType = 'removerTodos';
      this.confirmModal = true;
    },
    async executeAction() {
      if (this.actionType === 'aplicar') {
        const index = this.listadoCandidatos.findIndex(c => c.id === this.selectedItem.id);
        if (index !== -1) {
          this.listadoSeleccionados.push(this.listadoCandidatos[index]);
          this.listadoCandidatos.splice(index, 1);
        }
      } else if (this.actionType === 'aplicarTodos') {
        this.listadoSeleccionados.push(...this.candidatosFiltrados);
        this.listadoCandidatos = this.listadoCandidatos.filter(c => !this.candidatosFiltrados.some(fc => fc.id === c.id));
        this.paginacionCandidatos.pagina = 1;
      } else if (this.actionType === 'descartar') {
        const index = this.listadoSeleccionados.findIndex(c => c.id === this.selectedItem.id);
        if (index !== -1) {
          this.listadoCandidatos.push(this.listadoSeleccionados[index]);
          this.listadoSeleccionados.splice(index, 1);
        }
      } else if (this.actionType === 'removerTodos') {
        this.listadoCandidatos.push(...this.seleccionadosFiltrados);
        this.listadoSeleccionados = this.listadoSeleccionados.filter(c => !this.seleccionadosFiltrados.some(fc => fc.id === c.id));
        this.paginacionSeleccionados.pagina = 1;
      }

      this.confirmModal = false;
    },
  },
}
</script>

<style lang="scss" scoped>

</style>